import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="counter"
export default class extends Controller {
  static values = { target: Number }
  
  connect() {
    this.count = 0
    this.increment = Math.ceil(this.targetValue / 50) // Complete in ~50 steps
    this.countUp()
  }

  countUp() {
    if (this.count < this.targetValue) {
      this.count += this.increment
      if (this.count > this.targetValue) {
        this.count = this.targetValue
      }
      this.element.textContent = this.formatNumber(this.count)
      requestAnimationFrame(() => this.countUp())
    }
  }

  formatNumber(num) {
    return num.toLocaleString()
  }
}
